import { TableModel } from 'components/table/IdmTable';
import { PlannedRouteView } from 'core/graphql/CapacityPlanning/models';
import { secondsFromMidnightToHhMm } from 'core/utils/TimeSpanUtils';

/** One row per job step (delivery stop) of a single selected driver's route. */
export type StopRow = {
  sequence: number;
  arrival: string;
  /** The file's own DeliveryId for each Delivery grouped into this Stop. */
  deliveryCodes: string[];
  deliveries: number;
  load: number;
  latitude: number | null;
  longitude: number | null;
};

const jobStepType = 'job';

export const toStopRows = (route: PlannedRouteView): StopRow[] => {
  let sequence = 0;

  return route.steps
    .filter((step) => step.type === jobStepType)
    .map((step) => {
      sequence += 1;
      return {
        sequence,
        arrival: secondsFromMidnightToHhMm(step.arrivalSeconds),
        deliveryCodes: step.deliveryCodes,
        deliveries: step.deliveryIds.length,
        load: step.load,
        latitude: step.latitude ?? null,
        longitude: step.longitude ?? null,
      };
    });
};

// A DeliveryId is the parcel's own code from the source system, not a customer
// identifier. Customer address, name and phone are not part of a result step and
// must never be joined in - this table stays limited to sequence, arrival time,
// delivery ids, deliveries and load.
export const stopsTableModel: TableModel<StopRow> = {
  columns: [
    {
      title: '#',
      html: (row) => <span>{row.sequence}</span>,
      align: 'right',
      width: 1,
    },
    {
      title: 'Arrival',
      html: (row) => <span>{row.arrival}</span>,
      align: 'left',
      width: 2,
    },
    {
      // break-words and not break-all: a DeliveryId split across two lines reads
      // as two wrong codes, so the line breaks at the separators instead.
      title: 'Delivery IDs',
      html: (row) => (
        <span className="break-words">{row.deliveryCodes.join(', ')}</span>
      ),
      align: 'left',
      width: 5,
    },
    {
      title: 'Deliveries',
      html: (row) => <span>{row.deliveries}</span>,
      align: 'right',
      width: 3,
    },
    {
      title: 'Load after stop',
      html: (row) => <span>{row.load}</span>,
      align: 'right',
      width: 3,
    },
  ],
};

export default stopsTableModel;
